/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerLookupUserByEmailQueryResponse, TrimbleDiagnosticsControllerLookupUserByEmailQueryParams, TrimbleDiagnosticsControllerLookupUserByEmail400, TrimbleDiagnosticsControllerLookupUserByEmail401, TrimbleDiagnosticsControllerLookupUserByEmail403, TrimbleDiagnosticsControllerLookupUserByEmail404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerLookupUserByEmail";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleDiagnosticsControllerLookupUserByEmail } from "../../clients/trimble-diagnosticsService/trimbleDiagnosticsControllerLookupUserByEmail";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleDiagnosticsControllerLookupUserByEmailQueryKey = (params: TrimbleDiagnosticsControllerLookupUserByEmailQueryParams) => [{
  url: '/api/v1/trimble-user-email-diagnostics'
}, ...(params ? [params] : [])] as const;
export type TrimbleDiagnosticsControllerLookupUserByEmailQueryKey = ReturnType<typeof trimbleDiagnosticsControllerLookupUserByEmailQueryKey>;
export function trimbleDiagnosticsControllerLookupUserByEmailQueryOptions(params: TrimbleDiagnosticsControllerLookupUserByEmailQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleDiagnosticsControllerLookupUserByEmailQueryKey(params);
  return queryOptions<TrimbleDiagnosticsControllerLookupUserByEmailQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupUserByEmail400 | TrimbleDiagnosticsControllerLookupUserByEmail401 | TrimbleDiagnosticsControllerLookupUserByEmail403 | TrimbleDiagnosticsControllerLookupUserByEmail404>, TrimbleDiagnosticsControllerLookupUserByEmailQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleDiagnosticsControllerLookupUserByEmail(params, config);
    }
  });
}

/**
 * @summary Resolve a Trimble IAM user TID from an email
 * {@link /api/v1/trimble-user-email-diagnostics}
 */
export function useTrimbleDiagnosticsControllerLookupUserByEmail<TData = TrimbleDiagnosticsControllerLookupUserByEmailQueryResponse, TQueryData = TrimbleDiagnosticsControllerLookupUserByEmailQueryResponse, TQueryKey extends QueryKey = TrimbleDiagnosticsControllerLookupUserByEmailQueryKey>(params: TrimbleDiagnosticsControllerLookupUserByEmailQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrimbleDiagnosticsControllerLookupUserByEmailQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupUserByEmail400 | TrimbleDiagnosticsControllerLookupUserByEmail401 | TrimbleDiagnosticsControllerLookupUserByEmail403 | TrimbleDiagnosticsControllerLookupUserByEmail404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleDiagnosticsControllerLookupUserByEmailQueryKey(params);
  const query = useQuery({
    ...trimbleDiagnosticsControllerLookupUserByEmailQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupUserByEmail400 | TrimbleDiagnosticsControllerLookupUserByEmail401 | TrimbleDiagnosticsControllerLookupUserByEmail403 | TrimbleDiagnosticsControllerLookupUserByEmail404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}